import { farasod } from "./api"

const endpoint = "/sms-wallet"

export const getSMSBalance = async (branchId) => {
  const response = await farasod.get(`${endpoint}/${branchId}`)

  return response.data
}